'use client';

import Link from 'next/link';
import { Facebook, Twitter, Linkedin, Instagram } from 'lucide-react';
import { siteConfig } from '@/constant/config';
import { Logo } from '@/components/common/Logo';

const footerNavigation = {
  platform: [
    { name: 'Features', href: '/features' },
    { name: 'Pricing', href: '/pricing' },
    { name: 'How To Guides', href: '/how-to' },
    { name: 'FAQ', href: '/faq' },
  ],
  sports: [
    { name: 'Cricket Auctions', href: '/sports/cricket' },
    { name: 'Football Auctions', href: '/sports/football' },
  ],
  company: [
    { name: 'About Us', href: '/about' },
    { name: 'Contact', href: '/contact' },
  ],
  legal: [
    { name: 'Terms of Service', href: '/terms' },
    { name: 'Privacy Policy', href: '/privacy' },
  ],
  social: [
    {
      name: 'Twitter',
      href: `https://twitter.com/${siteConfig.social.twitter}`,
      icon: Twitter,
    },
    {
      name: 'Facebook',
      href: `https://facebook.com/${siteConfig.social.facebook}`,
      icon: Facebook,
    },
    {
      name: 'LinkedIn',
      href: `https://linkedin.com/company/${siteConfig.social.linkedin}`,
      icon: Linkedin,
    },
    {
      name: 'Instagram',
      href: `https://instagram.com/${siteConfig.social.instagram}`,
      icon: Instagram,
    },
  ],
};

export function StaticPageFooter() {
  return (
    <footer className="border-t border-gray-200 bg-white">
      <div className="layout py-8">
        <div className="grid gap-8 md:grid-cols-5">
          <div>
            <Link href="/" className="block">
              <Logo size="lg" />
            </Link>
            <p className="mt-4 text-sm text-gray-600">
              The ultimate platform for sports auctions and tournament
              management.
            </p>
          </div>

          <div>
            <h3 className="mb-4 text-sm font-semibold uppercase tracking-wider text-gray-900">
              Platform
            </h3>
            <ul className="space-y-2">
              {footerNavigation.platform.map((item) => (
                <li key={item.name}>
                  <Link
                    href={item.href}
                    className="text-gray-600 hover:text-primary-600"
                  >
                    {item.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="mb-4 text-sm font-semibold uppercase tracking-wider text-gray-900">
              Sports
            </h3>
            <ul className="space-y-2">
              {footerNavigation.sports.map((item) => (
                <li key={item.name}>
                  <Link
                    href={item.href}
                    className="text-gray-600 hover:text-primary-600"
                  >
                    {item.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="mb-4 text-sm font-semibold uppercase tracking-wider text-gray-900">
              Company
            </h3>
            <ul className="space-y-2">
              {footerNavigation.company.map((item) => (
                <li key={item.name}>
                  <Link
                    href={item.href}
                    className="text-gray-600 hover:text-primary-600"
                  >
                    {item.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="mb-4 text-sm font-semibold uppercase tracking-wider text-gray-900">
              Legal
            </h3>
            <ul className="space-y-2">
              {footerNavigation.legal.map((item) => (
                <li key={item.name}>
                  <Link
                    href={item.href}
                    className="text-gray-600 hover:text-primary-600"
                  >
                    {item.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mt-8 border-t border-gray-200 pt-8">
          <div className="flex items-center justify-between">
            <p className="text-sm text-gray-600">
              © {new Date().getFullYear()} Auction Chase. All rights reserved.
            </p>
            <div className="flex space-x-6">
              {footerNavigation.social.map((item) => (
                <a
                  key={item.name}
                  href={item.href}
                  className="text-gray-400 hover:text-primary-600"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <span className="sr-only">{item.name}</span>
                  <item.icon className="h-4 w-4" />
                </a>
              ))}
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
